import React from 'react'
import { Container, Title } from './styles'
import { usePatient } from '~/context'
import { withDashboardLoader } from '~/components/shared'
import { message } from '~/services'
import { AllergiesList } from '~/components/allergies'
import { useDocumentTitle, useFetchAllergies } from '~/hooks'

const AllergiesPage = (): JSX.Element => {
  useDocumentTitle(message('titles.allergies'))
  const { getVisiblePatientId } = usePatient()
  const patientId = getVisiblePatientId()

  const allergiesFetchParams = patientId ? { patientId } : null
  const { data, isLoading, error } = useFetchAllergies(allergiesFetchParams)
  const allergies = data ?? []
  const errorAllergies = error?.message ?? ''

  return (
    <Container>
      <Title>{message('allergies.allergies')}</Title>
      <AllergiesList allergies={allergies} isLoading={isLoading} error={errorAllergies} />
    </Container>
  )
}

export const Allergies = withDashboardLoader(AllergiesPage)
